import ListHeader from 'pix-orga/components/campaign/list-header';
<template>
  <article class="list-campaigns-page">
    <ListHeader />
    {{outlet}}
  </article>
</template>
